import { ApiCallResponse } from '@kts-front/call-api';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';

import { isCancelledRequest } from 'utils/isCancelledRequest';

export class NotificationsStore {
  showErrorByResponse(response: ApiCallResponse<any, any>): void {
    if (isCancelledRequest(response)) {
      return;
    }

    notifications.show({
      color: 'red',
      icon: <IconX />,
      message: response?.data?.data?.message ?? 'Произошла ошибка',
      autoClose: 4000,
    });
  }

  showError({ message, title, autoClose }: { message: string; title?: string; autoClose?: number }): void {
    notifications.show({
      color: 'red',
      title: title,
      icon: <IconX />,
      message: message ?? 'Произошла ошибка',
      autoClose: autoClose ?? 4000,
    });
  }

  showSuccess(message: string, title?: string): void {
    notifications.show({
      color: 'teal',
      title,
      icon: <IconCheck />,
      message,
      autoClose: 4000,
    });
  }
}
